<template>
    <div class="content-layout padded">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div v-if="curatedAlbum.description && curatedAlbum.description !== ''" class="page-heading">
                        <h1 class="mb-4">
                            {{ curatedAlbum.name }}
                        </h1>
                        <div class="row">
                            <div class="col-12 col-lg-7 description">
                                {{ curatedAlbum.description }}
                            </div>
                            <div class="col-lg-3 offset-lg-2 d-none d-lg-block search-blurb">
                                Our Curated Albums showcase just a <strong>handful of stock photos</strong> from our extensive stock image library. <strong>You can use the search bar to search for more images.</strong>
                            </div>
                        </div>
                    </div>
                    <h1 v-else class="page-heading">
                        {{ curatedAlbum.name }}
                    </h1>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div id="search-results-container" class="welcome curated pb-0" :class="{'pb-0':done}">
                        <div class="similar-images-wrap">
                            <stock-image-thumbnail v-for="image in curatedImages" :key="image.id" :image="image"/>
                            <infinite-loading :identifier="infiniteId" @infinite="getCuratedImages">
                                <div slot="spinner"/>
                                <div slot="no-results"/>
                            </infinite-loading>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="done" class="row">
                <div class="col-12">
                    <div class="announcement-banner large mb-4">
                        <b-icon-lightbulb class="btn-color"/>
                        <span><span>Images in Curated Albums are just a small selection from our wider library. <strong>Use the search bar</strong> on the top of this page to find more.</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import StockImageThumbnail from '~/components/StockImageThumbnail'

export default {
    components: { StockImageThumbnail },
    validate ({ params }) {
        return /\d/.test(params.curated_album_id)
    },
    async asyncData ({
        params,
        redirect
    }) {
        const fetchedCuratedAlbum = await axios.get(`/curated-album/${params.curated_album_id}`).then(rsp => rsp.data.data)

        if (fetchedCuratedAlbum) {
            if (!params.curated_album_slug || params.curated_album_slug !== fetchedCuratedAlbum.slug) {
                redirect(302, fetchedCuratedAlbum.link)
            }

            return {
                curatedAlbum: fetchedCuratedAlbum
            }
        } else {
            redirect('/')
        }
    },
    data () {
        return {
            curatedAlbumId: this.$route.params.curated_album_id,
            curatedAlbum: {},
            curatedImages: [],
            page: 1,
            infiniteId: +new Date(),
            randomSeed: Math.floor(Math.random() * 1000),
            done: false
        }
    },
    head () {
        const title = `${this.curatedAlbum.name} - curated album on Truestock`

        return {
            title,
            meta: [
                {
                    hid: 'og:title',
                    property: 'og:title',
                    content: title
                },
                {
                    hid: 'twitter:title',
                    name: 'twitter:title',
                    content: title
                },
                {
                    hid: 'og:image',
                    property: 'og:image',
                    content: this.curatedAlbum.url
                },
                {
                    hid: 'twitter:image',
                    name: 'twitter:image',
                    content: this.curatedAlbum.url
                }
            ]
        }
    },
    methods: {
        getCuratedImages ($state) {
            axios({
                method: 'get',
                url: `/curated-album/${this.curatedAlbumId}/images`,
                params: {
                    page: this.page,
                    randomSeed: this.randomSeed
                }
            }).then(rsp => rsp.data)
                .then((rsp) => {
                    if (rsp.data.length) {
                        this.page += 1
                        this.curatedImages.push(...rsp.data)
                        $state.loaded()
                    } else {
                        this.done = true
                        $state.complete()
                    }
                })
                .finally(() => {
                })
        }
    }
}
</script>
